import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import React, { useCallback, useState } from 'react';
import { URL } from '../../../constant';
import { A } from '../../common';
import { useAlert } from '../../../hooks';
import { handleTermsPage } from '../../../utils/utilityEtc';
import useAmplitude from '../../../hooks/useAmplitude';

function Agreed() {
  const history = useHistory();
  const { t } = useTranslation();
  const { setAmplitudeLog } = useAmplitude();
  const [Alert] = useAlert();
  const [allCheck, setAllCheck] = useState(false);
  const [agreeds, setAgreeds] = useState({
    terms: false,
    privacy: false,
    adult: false,
    marketing: false
  });

  const handleChange = useCallback((e) => {
    const name = e.target.name;
    const checked = e.target.checked
    if (name === 'all') {
      setAllCheck(checked);
      setAgreeds({ terms: checked, privacy: checked, adult: checked, marketing: checked });
    } else {
      const temp = {
        ...agreeds, [name]: checked
      }
      setAgreeds(temp);
      if (Object.values(temp).indexOf(false) > -1) setAllCheck(false)
      else setAllCheck(true);
    }

  }, [agreeds]);

  const handlePage = useCallback(() => {

    if ((agreeds.terms && agreeds.privacy && agreeds.adult) || allCheck) {
      setAmplitudeLog({ eventCategory: 'sign-up', eventName: '서비스이용 동의 설정' });
      history.push({
        pathname: URL.ACCOUNT.JOIN.I,
        state: agreeds
      });
    } else {
      Alert(t("MY_02_01.msg010"));
    }
  }, [agreeds, allCheck]);

  return (
    <React.Fragment>
      <div className="header_top gb">
        <div className="inner">
          <div className="btns_wrap cls">
            <div className="app_btn">
              <button className="btn_exit" type="button" onClick={() => history.goBack()}>
                <img src="./static/images/icon/btn_back.svg" alt="" />
              </button>
            </div>
            <div className="tit_gm center_tit24">{t("MY_02_01.msg001")}</div>
          </div>
        </div>
      </div>

      <div className="layout-def log_in agree gb">
        <div className="container">
          <div className="inner">
            <div className="center_wrap2">
              <div className="noti_wrap">
                <h1 className="noti1">{t("MY_02_01.msg002")}</h1>
                <div className="noti2" dangerouslySetInnerHTML={{ __html: t("MY_02_01.msg003")}}/>
              </div>

              <div className="chk_wrap">
                <div className="upper_box">
                  <div className="custom-radio-wrap custom-radio-white">
                    <input 
                      type="checkbox" 
                      id="all"
                      name="all"
                      checked={allCheck}
                      onChange={handleChange}
                    />
                    <label htmlFor="all">{t("MY_02_01.msg004")}</label>
                  </div>
                </div>
                <div className="lower_box">
                  <article className="cls">
                    <input
                      id="terms"
                      type="checkbox"
                      name="terms"
                      checked={agreeds.terms}
                      onChange={handleChange}
                    />
                    <label htmlFor="terms">{t("MY_02_01.msg005")}</label>
                    <div className="right">
                      <button 
                        className="arr"
                        onClick={() => handleTermsPage('terms')}
                      >
                        <img src="./static/images/icon/link_join_48x48@2x.png" alt="" />
                      </button>
                    </div>
                  </article>
                  <article className="cls">
                    <input
                      id="privacy"
                      type="checkbox"
                      name="privacy"
                      checked={agreeds.privacy}
                      onChange={handleChange}
                    />
                    <label htmlFor="privacy">{t("MY_02_01.msg006")}</label>
                    <div className="right">
                      <button 
                        className="arr" 
                        onClick={() => handleTermsPage('privacy')}
                      >
                        <img src="./static/images/icon/link_join_48x48@2x.png" alt="" />
                      </button>
                    </div>
                  </article>
                  <article className="cls">
                    <input
                      id="adult"
                      type="checkbox"
                      name="adult"
                      checked={agreeds.adult}
                      onChange={handleChange}
                    />
                    <label htmlFor="adult">{t("MY_02_01.msg007")}</label>
                  </article>
                  <article className="cls">
                    <input
                      id="marketing"
                      type="checkbox"
                      name="marketing"
                      checked={agreeds.marketing}
                      onChange={handleChange}
                    />
                    <label htmlFor="marketing">{t("MY_02_01.msg008")}</label>
                    <div className="right">
                      <button className="arr"
                        onClick={() => handleTermsPage('marketing')}
                      >
                        <img src="./static/images/icon/link_join_48x48@2x.png" alt="" /></button>
                    </div>
                  </article>
                </div>
              </div>
            </div>
            <div className="bottom_wrap btn_wrap static">
              <A 
                className="btn btn-white"
                onClick={handlePage}
              >
                {t("MY_02_01.msg009")}
              </A>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Agreed;